enum ImportCSVUploadingErrors {
  CSV_FILE_SIZE_ERROR = 'csv_file_size_error',
  CSV_FILE_SIZE_ERROR_ROW = 'csv_file_size_error_row',
  CSV_FORMAT_ERROR = 'csv_format_error',
  NO_INTERNET_CONNECTION = 'no_internet_connection',
  COMMON = 'common',
}

export default ImportCSVUploadingErrors;
